<div class="xl:flex h-screen md:-mr-3">
    <!-- Left Side -->
    <div class="xl:w-8 px-3 pt-3 pb-2 md:py-3" [attr.data-testid]="'left-side-container'">
        <!-- Recent Interactions -->
        <div class="hidden md:block" [attr.data-testid]="'recent-interactions-section'">
            <client-interaction-tab [clientDetails]="client" [clientId]="clientId" [showSkeleton]="showSkeleton$" [interactions]="clientInteractions$" [showMax]="3" [showCollapsed]="showCollapsed$" [clickFromTab]="clickfromTab"
              [height]="height" [interactionId]="interactionId" [attr.aria-label]="'client-interaction-tab'" [attr.data-testid]="'client-interaction-tab'">
            </client-interaction-tab>
        </div>
        <!-- Recent Interactions -->

        <!-- Load More -->
        <!-- <div
            *ngIf="!showSkeleton"
            class="surface-100 p-2 text-sm flex align-items-center justify-content-center text-primary cursor-pointer"
            [ngClass]="(clientInteractions$ | async)!.length == 0 ? 'opacity-40 pointer-events-none' : ''"
            (click)="changeTabClick()"
        >
            <i class="fa fa-refresh mr-2"></i>
            <span>{{'CLIENT_INTERACTION.MORE_ACTIVITY' | translate}}</span>
        </div>
        <p-skeleton *ngIf="showSkeleton" height="2rem" styleClass="w-full"></p-skeleton> -->
        <!-- Load More -->
    </div>
    <!-- Left Side -->

    <!-- Right Side -->
    <div class="xl:w-4 surface-0 xl:pr-3" [attr.data-testid]="'right-side-container'">
        <hr class="md:hidden border-300 border-top-1 border-bottom-none border-left-none border-right-none my-0" />

        <div class="p-3" [attr.data-testid]="'content-container'">
            <!-- Pinned Notes -->
            <div [attr.data-testid]="'pinned-notes-section'">
                <div class="flex align-items-center justify-content-between">
                    <h4 class="text-sm font-normal mb-0 flex align-items-center" [attr.data-testid]="'pinned-by-header'">
                        <strong class="mr-2">{{'CLIENT_PROFILE.PINNED_BY' | translate }}</strong>
                        <p-skeleton *ngIf="showSkeleton" height="1.35rem" styleClass="w-2rem" [attr.data-testid]="'pinned-by-skeleton'"></p-skeleton>
                    </h4>

                    <p-button *ngIf="!showSkeleton && client && (client.note === null || client.note === '')" [label]="'CLIENT_PROFILE.ADD_NEW' | translate" icon="fa fa-plus-circle" styleClass="text-sm p-button-text" (click)="showTextbox= true;clientNotes= client.note"
                        [attr.aria-label]="'add-new-note-button'" [attr.data-testid]="'add-new-note-button'">
                    </p-button>
                    <p-skeleton *ngIf="showSkeleton" height="2rem" styleClass="w-5rem" [attr.data-testid]="'add-note-skeleton'"></p-skeleton>
                </div>
                <div *ngIf="!showSkeleton" class="border-round bg-green-50 p-3 text-xs mt-2" [attr.data-testid]="'notes-content'">
                    <div class="flex align-items-center justify-content-between" *ngIf="client && client.note !== null && client.note !== ''" [attr.data-testid]="'note-header'">
                        <span class="text-600" [attr.data-testid]="'note-update-date'">{{ client.note_updated_date | datetimeformat : 'atDate' }}</span>
                        <span *ngIf="!showNotes" class="flex align-items-center justify-content-end text-600 -mt-3" [attr.data-testid]="'note-actions'">
                            <i *ngIf="!showTextbox" class="fa fa-pencil cursor-pointer mr-2" (click)="showTextbox= true;clientNotes= client.note"
                                [attr.aria-label]="'edit-note-button'" [attr.data-testid]="'edit-note-button'"></i>
                            <i *ngIf="!showTextbox" class="fa fa-trash-alt cursor-pointer" (click)="deleteNotes()"
                                [attr.aria-label]="'delete-note-button'" [attr.data-testid]="'delete-note-button'"></i>
                        </span>
                    </div>
                    <div *ngIf="client && client.note !== null && client.note !== ''" [attr.data-testid]="'note-details'">
                        <div class="mt-2">
                            <div class="mb-2" [attr.data-testid]="'note-author'">{{'CLIENT_PROFILE.COMMENT_BY' | translate }} <strong class="cursor-pointer text-primary" *ngIf="getStaffDetails(client.note_updated_by) as staff">{{ staff.name || " - " }}</strong></div>
                            <div *ngIf="!showTextbox" [innerHTML]="client.note" [attr.data-testid]="'note-text'"></div>
                        </div>
                    </div>

                    <div class="text-center -mb-3" *ngIf="client && (client.note === null || client.note === '')" [attr.data-testid]="'empty-notes'">
                        <h6 class="text-sm font-normal mb-4" *ngIf="!showTextbox" [attr.data-testid]="'no-notes-message'">{{'CLIENT_PROFILE.NO_NOTES' | translate }}</h6>
                        <img *ngIf="!showTextbox" src="/assets/img/empty-state-pinned-notes-img.svg" alt="No notes to show!" [attr.data-testid]="'empty-notes-image'" />
                    </div>
                    <div *ngIf="showTextbox" [attr.data-testid]="'note-edit-form'">
                        <textarea pInputTextarea class="text-sm w-full h-4rem my-2" [(ngModel)]="clientNotes" placeholder="Comment"
                            [attr.aria-label]="'note-textarea'" [attr.data-testid]="'note-textarea'"></textarea>
                        <div class="text-right">
                            <i (click)="saveNotes()" class="fa fa-pencil cursor-pointer mr-2"
                                [attr.aria-label]="'save-note-button'" [attr.data-testid]="'save-note-button'"></i>
                            <i (click)="showTextbox= false;clientNotes=''" class="fa fa-trash-alt-alt cursor-pointer"
                                [attr.aria-label]="'cancel-edit-button'" [attr.data-testid]="'cancel-edit-button'"></i>
                        </div>
                    </div>
                </div>
                <!-- Notes Card -->

                <p-skeleton *ngIf="showSkeleton" height="9.325rem" styleClass="w-full mt-2" [attr.data-testid]="'notes-skeleton'"></p-skeleton>
            </div>
            <!-- Pinned Notes -->

            <!-- referred by -->
            <div class="mt-3" [attr.data-testid]="'referred-by-section'">
                <h4 class="text-xs font-normal text-600 mb-1 uppercase" [attr.data-testid]="'referred-by-header'">{{'CLIENT_PROFILE.REFERRED_BY' | translate }}</h4>
                <ng-container *ngIf="!showSkeleton">
                    <div *ngIf="referredByClient; else nodata" [attr.data-testid]="'referred-by-content'">
                        <strong class="text-primary" [attr.data-testid]="'referred-by-name'"> {{referredByClient.clt_full_name}} ({{referredByClient.clt_id}}) </strong>
                    </div>
                    <ng-template #nodata>
                        <strong class="block text-sm" [attr.data-testid]="'no-referral-message'">-</strong>
                    </ng-template>
                </ng-container>

                <div *ngIf="showSkeleton" class="flex flex-wrap" [attr.data-testid]="'referred-by-skeleton'">
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                </div>
            </div>
            <!-- referred by -->

            <!-- Open Referrals -->
            <div class="mt-3" [attr.data-testid]="'open-referrals-section'">
                <h4 class="text-xs font-normal text-600 mb-1" [attr.data-testid]="'open-referrals-header'">{{'CLIENT_PROFILE.OPEN_REFERRALS' | translate }}</h4>
                <ng-container *ngIf="!showSkeleton">
                    <div *ngIf="getOpenReferrals().length > 0; else nodata" [attr.data-testid]="'open-referrals-list'">
                        <ul *ngIf="getOpenReferrals() as referrals" class="flex flex-wrap list-none m-0 p-0 text-sm">
                            <li *ngFor="let referral of referrals" [attr.data-testid]="'referral-item-' + referral.id"><strong class="text-primary">{{referral.referee_name}}</strong>,</li>
                        </ul>
                    </div>
                    <ng-template #nodata>
                        <strong class="block text-sm" [attr.data-testid]="'no-open-referrals-message'">{{'CLIENT_PROFILE.NO_REFERRALS' | translate }}</strong>
                    </ng-template>
                </ng-container>

                <div *ngIf="showSkeleton" class="flex flex-wrap" [attr.data-testid]="'open-referrals-skeleton'">
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                </div>
            </div>
            <!-- Open Referrals -->

            <!-- Open Referrals -->
            <div class="my-3" [attr.data-testid]="'success-referrals-section'">
                <h4 class="text-xs font-normal text-600 mb-1" [attr.data-testid]="'success-referrals-header'">{{'CLIENT_PROFILE.SUCESS_REFERRALS' | translate }}</h4>
                <ng-container *ngIf="!showSkeleton">
                    <div *ngIf="getSuccessfullReferrals().length > 0; else nodata" [attr.data-testid]="'success-referrals-list'">
                        <ul *ngIf="getSuccessfullReferrals() as referrals" class="flex flex-wrap list-none m-0 p-0 text-sm">
                            <li *ngFor="let referral of referrals" [attr.data-testid]="'success-referral-item-' + referral.id"><strong class="text-primary">{{referral.referee_name}}</strong>,</li>
                        </ul>
                    </div>
                    <ng-template #nodata>
                        <strong class="block text-sm" [attr.data-testid]="'no-success-referrals-message'">{{'CLIENT_PROFILE.NO_SUCESS_REFERRALS' | translate }}</strong>
                    </ng-template>
                </ng-container>
                <div *ngIf="showSkeleton" class="flex flex-wrap" [attr.data-testid]="'success-referrals-skeleton'">
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                </div>
            </div>
            <!-- Open Referrals -->

            <!-- Relation(s) -->
            <div class="mt-4 mb-3" *ngIf="client && client.is_child" [attr.data-testid]="'relations-section'">
                <h4 class="text-xs font-normal text-600 mb-1" [attr.data-testid]="'relations-header'">{{'CLIENT_PROFILE.RELATIONS' | translate }}</h4>
                <ul *ngIf="!showSkeleton && parentClient" class="flex flex-wrap list-none m-0 p-0 text-sm" [attr.data-testid]="'relations-list'">
                    <li [attr.data-testid]="'parent-relation'"><strong class="text-primary">{{ parentClient.full_name }}</strong>, ({{client.relation === 'Child' ? 'Parent' : client.relation}})</li>
                </ul>
                <div *ngIf="showSkeleton" class="flex flex-wrap" [attr.data-testid]="'relations-skeleton'">
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                    <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                </div>
            </div>
            <!-- Relation(s) -->

            <!-- Relation(s) Child -->
            <div class="mt-4 mb-3" *ngIf="client && client.childs" [attr.data-testid]="'child-relations-section'">
                <h4 class="text-xs font-normal text-600 mb-1" [attr.data-testid]="'child-relations-header'">{{'CLIENT_PROFILE.RELATIONS' | translate }}</h4>
                <ul class="flex flex-wrap list-none m-0 p-0 text-sm" [attr.data-testid]="'child-relations-list'">
                  <li *ngFor="let child of client.childs ; let i = index" [attr.data-testid]="'child-relation-item-' + child.id">
                    <strong class="text-primary">{{ child.full_name }}</strong> ({{ child.relation }}){{i === client.childs.length - 1 ? '' : ', &nbsp;'}}
                  </li>
                </ul>
                <div *ngIf="showSkeleton" class="flex flex-wrap" [attr.data-testid]="'child-relations-skeleton'">
                  <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="w-3rem mr-2 mb-2"></p-skeleton>
                </div>
              </div>

            <!-- Relation(s) -->


            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mb-3">

            <!-- Eligible Offers -->
            <div class="surface-0 border-1 border-300 border-round text-sm" [attr.data-testid]="'eligible-offers-section'">
                <!-- Card Header -->
                <div (click)="showEligibleOffers=!showEligibleOffers" class="border-bottom-1 border-300 px-3 py-2 flex justify-content-between align-items-center cursor-pointer" [attr.data-testid]="'offers-header'">
                    <strong [attr.data-testid]="'offers-title'">{{'CLIENT_PROFILE.ELIGIBLE_OFFERS' | translate}}</strong>
                    <i [ngClass]="showEligibleOffers ? 'fa-angle-up' : 'fa-angle-down' " class="fa text-xs ml-2 h-1rem w-1rem border-circle p-1 bg-primary flex align-items-center justify-content-center"
                        [attr.aria-label]="'toggle-offers-button'" [attr.data-testid]="'toggle-offers-button'"></i>
                </div>
                <!-- Card Header -->

                <!-- Card Body -->
                <div class="p-3" *ngIf="showEligibleOffers" [attr.data-testid]="'offers-content'">
                    <ul *ngIf="!showSkeleton" class="list-none p-0 m-0" [attr.data-testid]="'offers-list'">
                        <li class="mb-3" *ngFor="let offer of clientOffers$.value" [attr.data-testid]="'offer-item-' + offer.id">
                            <strong class="block text-primary" [attr.data-testid]="'offer-name-' + offer.id">{{offer.name_primary_language || offer.name_secondary_language }} <i class="fa fa-copy ml-2" [attr.aria-label]="'copy-offer-button'" [attr.data-testid]="'copy-offer-button'"></i></strong>
                            <span class="block mt-1" [attr.data-testid]="'offer-details-' + offer.id">
                                <strong>{{offer.name_primary_language || offer.name_secondary_language }}</strong> {{'CLIENT_PROFILE.OFFER_EXPIRES_ON' | translate}} <strong>{{offer.expiry_date | datetimeformat : 'MMM d, yyyy'}}</strong>
                            </span>
                        </li>
                    </ul>
                    <div *ngIf="showSkeleton" [attr.data-testid]="'offers-skeleton'">
                        <p-skeleton height="1.35rem" width="100%" styleClass="mb-3"></p-skeleton>
                        <p-skeleton height="1.35rem" width="100%" styleClass="mb-3"></p-skeleton>
                        <p-skeleton height="1.35rem" width="100%" styleClass="mb-3"></p-skeleton>
                    </div>
                    <p-button (click)="showOffer()" [label]="'CLIENT_PROFILE.BTN_ADDOFFER' | translate" styleClass="p-button-outlined text-sm font-bold"
                        [attr.aria-label]="'add-offer-button'" [attr.data-testid]="'add-client-overview-offer-button'">
                    </p-button>
                </div>
                <!-- Card Body -->
            </div>
            <!-- Eligible Offers -->
        </div>
    </div>
    <!-- Right Side -->
</div>

<!-- Add Offer Modal-->
<p-dialog [(visible)]="addOfferModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '700px'}" styleClass="no-header-modal no-backdrop-overlay"
    aria-label="add-offer-dialog">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="px-3 py-2 flex align-items-center justify-content-between border-bottom-1 border-300" [attr.data-testid]="'dialog-header'">
            <h2 class="mb-0 text-sm flex align-items-center" [attr.data-testid]="'dialog-title'">
                {{ 'CLIENT_PROFILE.ADD_OFFER_to' | translate }}
                <p-avatar *ngIf="client.image; else noContactPic" [image]="client.image" size="small" shape="circle" [attr.aria-label]="'client-avatar'" [attr.data-testid]="'client-avatar'"> </p-avatar>
                <ng-template #noContactPic>
                    <p-avatar [label]="client.full_name | titlecase | shortName" shape="circle" [attr.aria-label]="'client-avatar-fallback'" [attr.data-testid]="'client-avatar-fallback'"></p-avatar>
                </ng-template>
                {{ client.full_name }}
            </h2>
            <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="addOfferModal = false"
                [attr.aria-label]="'close-dialog-button'" [attr.data-testid]="'close-dialog-button'"></i>
        </div>
        <!-- Header -->

        <p-table [value]="tableData.value" styleClass="" responsiveLayout="scroll" [loading]="loading.value"
            [attr.aria-label]="'offers-table'" [attr.data-testid]="'offers-table'">
            <ng-template pTemplate="header">
                <tr class="text-xs font-bold">
                    <th class="text-600 surface-300 py-2 white-space-nowrap" [attr.data-testid]="'offer-name-header'">{{'ADMIN.COUPON.OFFER_NAME' | translate}}</th>
                    <th class="text-600 surface-300 py-2 white-space-nowrap" [attr.data-testid]="'discount-type-header'">{{'ADMIN.COUPON.DISCOUNT_TYPE' | translate}}</th>
                    <th class="text-600 surface-300 py-2 white-space-nowrap" [attr.data-testid]="'coupon-method-header'">{{'ADMIN.COUPON.COUPON_METHOD' | translate}}</th>
                    <th class="text-600 surface-300 py-2 white-space-nowrap" [attr.data-testid]="'eligibility-header'">{{'CLIENT_PROFILE.ELIGIBILITY' | translate}}</th>
                    <th class="text-600 surface-300 py-2 white-space-nowrap" [attr.data-testid]="'actions-header'"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-offer>
                <tr class="text-sm" *ngIf="tableData.value" [attr.data-testid]="'offer-row-' + offer.id">
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" [attr.data-testid]="'offer-name-cell-' + offer.id">{{offer.name_primary_language}}</td>
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" *ngIf="offer.discount_type === 'Percentage'" [attr.data-testid]="'percentage-discount-cell-' + offer.id"><i class="fa fa-percentage text-600"></i></td>
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" *ngIf="offer.discount_type === 'Value'" [attr.data-testid]="'value-discount-cell-' + offer.id"><i class="fa fa-dollar text-600"></i></td>
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" [attr.data-testid]="'coupon-type-cell-' + offer.id">{{offer.coupon_type}}</td>
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" [attr.data-testid]="'eligibility-cell-' + offer.id">
                        <div class="flex align-items-center">
                            <span [ngClass]="isOfferAdded(offer.id) ? 'bg-green-500' : 'bg-error' " class="border-circle h-1rem w-1rem mr-2" [attr.data-testid]="'eligibility-indicator-' + offer.id"></span>
                            <span *ngIf="isOfferAdded(offer.id)" [attr.data-testid]="'eligible-text-' + offer.id">{{'CLIENT_PROFILE.ELIGIBLE' | translate}}</span>
                            <span *ngIf="!isOfferAdded(offer.id)" [attr.data-testid]="'non-eligible-text-' + offer.id">{{'CLIENT_PROFILE.NON_ELIGIBLE' | translate}}</span>
                        </div>
                    </td>
                    <td class="py-2 border-bottom-1 border-300 white-space-nowrap" [attr.data-testid]="'actions-cell-' + offer.id">
                        <p-button *ngIf="!isOfferAdded(offer.id)" [label]="'common.BUTTONS.BTN_ADD' | translate" styleClass="text-sm" (onClick)="AddCouponToClient(offer)"
                            [attr.aria-label]="'add-coupon-button'" [attr.data-testid]="'add-coupon-button-' + offer.id"></p-button>
                        <p-button *ngIf="isOfferAdded(offer.id)" [label]="'common.BUTTONS.BTN_REMOVE' | translate" styleClass="text-sm p-button-danger p-button-outlined" (onClick)="RemoveCouponToClient(offer)"
                            [attr.aria-label]="'remove-coupon-button'" [attr.data-testid]="'remove-coupon-button-' + offer.id"></p-button>
                    </td>
                </tr>
                <tr class="text-sm" *ngIf="tableData.value.length === 0" [attr.data-testid]="'empty-offers-row'">
                    <td colspan="5" class="py-5 text-center font-bold border-bottom-1 border-300 white-space-nowrap w-full">
                        <div class="my-3 w-full text-center" [attr.data-testid]="'no-offers-message'">{{'CLIENT_PROFILE.NO_OFFER' | translate}}</div>
                        <img width="220" src="/assets/img/img-empty-state-offer.svg" alt="No Records!" [attr.data-testid]="'empty-offers-image'" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</p-dialog>
<!-- Add Offer Modal-->



